export const fromApiUserData = (data) => {
  return {
    username: data.username,
    firstName: data.first_name,
    lastName: data.last_name,
  };
};
